"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isOptionChecked;

function isOptionChecked(option, currentValue) {
  if (!currentValue) {
    return false;
  }

  return !option.disabled && option.value === currentValue;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/RadioButtonGroup/helpers/isOptionChecked.js
// module id = HO5d
// module chunks = 0